// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"1d2f9659","824":"7c8cd472","2932":"d4f38895","8803":"99b614bf"}[chunkId] + ".chunk.css";
};